import { render, staticRenderFns } from "./AnchorLinks.vue?vue&type=template&id=0580af18&"
import script from "./AnchorLinks.vue?vue&type=script&lang=js&"
export * from "./AnchorLinks.vue?vue&type=script&lang=js&"
import style0 from "./AnchorLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports